module.exports = __webpack_public_path__ + "img/lageplan_800.6846edd2.png";